export * from './bericht-post-request.interface';
export * from './bericht-post-response.interface';
export * from './bericht-post.shapes';
